import { baseApi } from './baseApi';

export interface Organization {
    id: string;
    name: string;
    email: string;
    phone: string;
    org_price: number;
    address: string;
    city: number;
    state: number;
    country: number;
    license_no: string;
    license_id: string;
    active_date: string;
    end_date: string;
    type: number;
    limit_type: number;
    limit: number;
    purchase_count: number;
    available_limit: number;
    status: number;
    user_id: string;
    createdAt: string;
    updatedAt: string;
    deleteAt: null | string;
    country_name: string;
    state_name: string;
    city_name: string;
    role_name: string;
    User: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        phone: string;
        address: string;
        city: number;
        state: number;
        country: number;
        role_id: string;
        verification_code: string;
        status: string;
        createdAt: string;
        updatedAt: string;
        deleteAt: null | string;
    };
}

export interface OrganizationResponse {
    organization: Organization;
    message: string;
}

export const organizationApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getOrganizationById: builder.query<OrganizationResponse, string>({
            query: (id) => ({
                url: `/organization/getOrganizationById/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'Organization', id }],
        }),
    }),
});

export const { useGetOrganizationByIdQuery } = organizationApi;
